TS.ns('WL');

WL.leasingOfferScheduleModel = new Class({
    Extends: WL.documentBase,

    initialize: function (config) {
        var me = this;

        me.parent(config);

        var scheduleCellParamView = me.getDomainProperty('ScheduleCellParamView');

        me.showParamValueDecimal = ko.computed(function () {
            if (me.Document.ScheduleCellParamTypeId)
                if (me.Document.ScheduleCellParamTypeId() === 1)
                    return true;
            return false;
        });

        me.showParamValueDate = ko.computed(function () {
            if (me.Document.ScheduleCellParamTypeId)
                if (me.Document.ScheduleCellParamTypeId() === 2)
                    return true;
            return false;
        });

        me.showParamValueBool = ko.computed(function () {
            if (me.Document.ScheduleCellParamTypeId)
                if (me.Document.ScheduleCellParamTypeId() === 3)
                    return true;
            return false;
        });

        me.showParamValueString = ko.computed(function () {
            if (me.Document.ScheduleCellParamTypeId)
                if (me.Document.ScheduleCellParamTypeId() === 4)
                    return true;
            return false;
        });
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var scheduleView = me.getDomainProperty('ScheduleView');
        if (scheduleView != null) {
            scheduleView.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        if (dataItem.IsInvoiced != null && dataItem.IsInvoiced != 0) {
                            row.addClass("schedule_blue_row");
                        }
                    }
                }
            }
        }
    }
});

